import React from "react";
import { PdfSlateBaseParentBlockNode, PdfSlateEndnote, PdfSlateImage, PdfSlateLink, PdfSlateTextNode, PdfTheme } from "../types";
import { SlateBlockquote, SlateListBlock } from "../../../../types/slate";
import { BLOCKQUOTE_MARGIN, MEDIUM_MARGIN } from "../configs";
import Paragraph from "./Paragraph";
import { Style } from "@surge-global-engineering/rpdf-types";

interface BlockquoteProps {
  index: number;
  nodeIndex: number;
  theme: PdfTheme;
  endNotes: PdfSlateEndnote[];
  style?: Style;
  blockquoteNode: SlateBlockquote;
  children: (
    | PdfSlateEndnote
    | PdfSlateTextNode
    | PdfSlateLink
    | PdfSlateBaseParentBlockNode
    | SlateListBlock
    | PdfSlateImage
  )[];
  parentType: string;
  endNotesOffset?: number;
}

export const Blockquote: React.FC<BlockquoteProps> = ({ index, nodeIndex, theme, endNotes, style, blockquoteNode, children, parentType, endNotesOffset }: BlockquoteProps) => {
  const canJustifyText = !["align_center", "align_right"].includes(parentType);

  return (
    <>
      <Paragraph
        key={`blockquote-${index}`}
        theme={theme}
        endNotesOffset={endNotesOffset}
        nodeIndex={nodeIndex + 10}
        endNotes={endNotes}
        canJustifyText={canJustifyText}
        indented={false}
        parentType={parentType}
        style={{
          ...style,
          marginTop: MEDIUM_MARGIN,
          marginBottom: blockquoteNode.quotee ? 0 : MEDIUM_MARGIN,
          marginLeft: BLOCKQUOTE_MARGIN,
          marginRight: BLOCKQUOTE_MARGIN,
        }}
        showFirstSentenceFormatting={false}
      >
        {children}
      </Paragraph>
      {blockquoteNode.quotee ? (
        <Paragraph
          key={`blockquote-${index}-quotee`}
          theme={theme}
          nodeIndex={nodeIndex + 10}
          endNotes={endNotes}
          parentType={"align_right"}
          showFirstSentenceFormatting={false}
          style={{
            textAlign: "right",
            marginBottom: MEDIUM_MARGIN,
            marginLeft: BLOCKQUOTE_MARGIN,
            marginRight: BLOCKQUOTE_MARGIN,
          }}
        >
          {[{ text: blockquoteNode.quotee }]}
        </Paragraph>
      ) : null}
    </>
  );
};
